module.exports = __webpack_public_path__ + "themes/giveandgo/assets/img/blackglass-premium.307d706e.png";